module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_golfclub_d473d6601c832e7d15c79396993e00e2.png";